"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _includes = _interopRequireDefault(require("lodash/includes"));
var EMPTY_FORMAT = [undefined, null, '', '0001-01-01', '0001-01-01T00:00:00Z'];
/** @deprecated check null/undefined yourself and if you're using this to check for zero date values, work with your team to make sure the API doesn't return them*/
var _default = exports["default"] = function _default(input) {
  return !(0, _includes["default"])(EMPTY_FORMAT, input);
};